import { buildAgentModelLabel } from '../build-model';

export interface BuildModelSummaryProps {
  model: string | null | undefined;
  onEdit?: () => void;
}

export function BuildModelSummary({ model, onEdit }: BuildModelSummaryProps): React.JSX.Element {
  return (
    <p className="text-xs leading-relaxed text-white/40" data-testid="build-model-summary">
      Build model: <span className="font-medium text-white/65">{buildAgentModelLabel(model)}</span>
      {onEdit && (
        <>
          {' '}
          <button
            type="button"
            onClick={onEdit}
            className="underline underline-offset-2 hover:text-white/70"
          >
            Edit in Settings
          </button>
        </>
      )}
    </p>
  );
}
